import {
    URLAPI,
    OBSERVATIONS_PATH,
    OBSERVATION_CREATE_PATH,
    WORK_SUBPROCESS_OBSERVATION_CREATE_PATH,
    OBSERVATION_UPDATE_PATH,
    WORK_SUBPROCESS_OBSERVATION_DELETE_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_observations: {
        data: [],
        status: 0,
        message: {},
    },
    _create_observation: {
        data: {},
        status: 0,
        message: {},
    },
    _update_observation: {
        data: {},
        status: 0,
        message: {},
    },
    _create_work_subprocess_observation: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_work_subprocess_observation: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_OBSERVATIONS = "GET_ALL_OBSERVATIONS";
export const CREATE_OBSERVATION = "CREATE_OBSERVATION";
export const UPDATE_OBSERVATION = "UPDATE_OBSERVATION";
export const CREATE_WORK_SUBPROCESS_OBSERVATION = "CREATE_WORK_SUBPROCESS_OBSERVATION";
export const DELETE_WORK_SUBPROCESS_OBSERVATION = "DELETE_WORK_SUBPROCESS_OBSERVATION";

export const observations_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_OBSERVATIONS:
            return {
                ...state,
                _get_all_observations: action.payload,
            };
        case CREATE_OBSERVATION:
            return {
                ...state,
                _create_observation: action.payload,
            };
        case UPDATE_OBSERVATION:
            return {
                ...state,
                _update_observation: action.payload,
            };
        case CREATE_WORK_SUBPROCESS_OBSERVATION:
            return {
                ...state,
                _create_work_subprocess_observation: action.payload,
            };
        case DELETE_WORK_SUBPROCESS_OBSERVATION:
            return {
                ...state,
                _delete_work_subprocess_observation: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllObservations = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${OBSERVATIONS_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_OBSERVATIONS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_OBSERVATIONS,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_OBSERVATIONS,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createObservation = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${OBSERVATION_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_OBSERVATION,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_OBSERVATION,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_OBSERVATION,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateObservation = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${OBSERVATION_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_OBSERVATION,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_OBSERVATION,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_OBSERVATION,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createWorkSubprocessObservation = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            if (key !== 'subprocesos') {
                form.append(key, data[key]);
            } else {
                form.append(key, JSON.stringify(data[key]));
            }
        }
        const response = await axios.post(
            `${URLAPI}${WORK_SUBPROCESS_OBSERVATION_CREATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_WORK_SUBPROCESS_OBSERVATION,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_WORK_SUBPROCESS_OBSERVATION,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_WORK_SUBPROCESS_OBSERVATION,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const deleteWorkSubprocessObservation = (token, id_work_subprocess, id_observation) => async (dispatch) => {
    try {
        const response = await axios.delete(`${URLAPI}${WORK_SUBPROCESS_OBSERVATION_DELETE_PATH}${id_work_subprocess}/${id_observation}/`,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: DELETE_WORK_SUBPROCESS_OBSERVATION,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: DELETE_WORK_SUBPROCESS_OBSERVATION,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_WORK_SUBPROCESS_OBSERVATION,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_observations = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
